<template>
  <div id="app-div">
    <div style="width: 100%; margin: 0; padding: 0">
      <div>
        <label style="margin-right: 20px; margin-left: 180px">模版类型：</label>
        <a-select defaultValue="0" style="width: 250px" @change="handleChange">
          <a-select-option value="0">收稿</a-select-option>
          <a-select-option value="1">审稿</a-select-option>
          <a-select-option value="2">催审</a-select-option>
          <a-select-option value="3">缴费</a-select-option>
          <a-select-option value="4">催缴</a-select-option>
          <a-select-option value="5">退改</a-select-option>
          <a-select-option value="6">退稿</a-select-option>
          <a-select-option value="7">采用</a-select-option>
        </a-select>
      </div>

      <div style="margin-top: 15px">
        <label style="margin-right: 20px; margin-left: 150px"
          >短信模版语言：</label
        >
        <a-select defaultValue="0" style="width: 250px" @change="handleChange">
          <a-select-option value="0">中文</a-select-option>
          <a-select-option value="1">英文</a-select-option>
        </a-select>
      </div>

      <div style="margin-top: 15px">
        <label style="margin-right: 20px; margin-left: 150px"
          >短信模版名称：</label
        >
        <a-input placeholder="请输入" style="width: 250px" />
      </div>

      <div style="margin-top: 15px; width: 100%">
        <div style="float: left; margin-left: 180px">短信内容：</div>
        <div
          contenteditable="true"
          style="
            height: 250px;
            width: 600px;
            border: 1px solid #bcbcbc;
            margin-left: 275px;
            overflow-y: scroll;
          "
        >
          尊敬的[user_real_name][sex]：您好！您在我社([unit_name])的稿件《[title]》（稿件编号：[file_no]）已被退稿。具体退稿意见请登录我们的网站[web_site]查看。
        </div>
      </div>

      <div style="margin-top: 20px">
        <label style="margin-right: 20px; margin-left: 180px">状态启用：</label>
        <a-switch
          checkedChildren="开"
          unCheckedChildren="关"
          defaultunChecked
        />
        <label style="margin-right: 20px; margin-left: 180px">查看变量：</label>
        <a-switch
          unCheckedChildren="关"
          checkedChildren="开"
          defaultunChecked
          @change="changeState"
        />
        <div
          v-if="state"
          style="
            height: 200px;
            width: 600px;
            border: 1px solid #bcbcbc;
            margin-top: 10px;
            margin-left: 275px;
            overflow-y: scroll;
          "
        >
          邮件内容关键词是系统可以自动提供的，只要在模板中增加后，系统会自动用真实数据替换，请根据需要
          选择关键词。[user_real_name]:作者真实姓名 [sex]：性别
          [title]：稿件标题 [file_no]：稿件编号[discard_advice]：退稿意见
          [web_site]：网址 [user_name]：用户名[password]：密码 [address]：地址
          [telephone]：电话 [E-mail]：邮箱
        </div>
      </div>

      <div style="margin-top: 50px; margin-left: 700px">
        <a-button style="margin-right: 50px" @click="cancelAdd">取消</a-button>
        <a-button type="primary" @click="countDown">保存</a-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      state: false,
      count: false
    };
  },
  methods: {
    handleChange() {},
    changeState() {
      this.state = !this.state;
    },
    cancelAdd() {
      this.$router.push({
        path: '/ShortNote'
      });
    },
    countDown() {
      this.count = !this.count;
      let secondsToGo = 3;
      const modal = this.$success({
        title: '操作成功！',
        content: `${secondsToGo}秒后自动关闭`
      });
      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: `${secondsToGo}秒后自动关闭`
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
      }, secondsToGo * 1000);
    }
  }
};
</script>
<style>
</style>


